<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Add Checklist'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    @if (loaded) {
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'Create a checklist, then assign it to a job so your Pro can see what you want done.'" />
      </tidy-row>
      <tidy-card>
        <form [formGroup]="form">
          @if (form?.value?.whatToDo === 'copy' && listToCopyItems?.length == 0) {
            <tidy-row>
              <tidy-text
                [body]="'All your checklists have rooms specific to a property so cannot be copied to other properties. Create a checklist with no property specific rooms to copy it.'" />
            </tidy-row>
          }
          @if (form?.value?.whatToDo === 'copy' && listToCopyItems?.length > 0) {
            <tidy-row class="field-top-padding field-bottom-padding">
              <tidy-select
                [icon]="'assets/svg/list.svg'"
                [label]="'Select List to Copy to this Property'"
                [form]="form.controls.listToCopy"
                formControlName="listToCopy"
                [items]="listToCopyItems" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'Note: you can only copy lists not associated with a property to another property.'" />
            </tidy-row>
          }
          @if (form?.value?.whatToDo === 'new') {
            <tidy-row>
              <tidy-input
                [label]="'List Name'"
                formControlName="listName"
                [form]="form.controls.listName"
                [icon]="'assets/svg/list-circle-outline.svg'"
                [activeIcon]="'assets/svg/list-circle-outline.svg'"
                [submitted]="submitted"
                [errorMessage]="'Please enter the name of the list.'" />
            </tidy-row>
            <tidy-row>
              <tidy-textarea
                label="List Description"
                [icon]="'assets/svg/create-outline.svg'"
                [submitted]="submitted"
                [errorMessage]="'Please enter a description of the list.'"
                [form]="form.controls.listDescription"
                formControlName="listDescription" />
            </tidy-row>
            @if (hasToDoLists) {
              <tidy-row>
                <tidy-checkbox
                  [(checked)]="default"
                  [items]="[{viewValue: 'Set as default list at all properties', value: false}]"
                  [initValue]="default" />
              </tidy-row>
            }
            <tidy-row [alignLastItemRight]="true">
              <div style="display: flex; align-items: center; gap: 8px; white-space: nowrap;">
                <tidy-image
                  [src]="'assets/img/camera.svg'"
                  class='header-size' />
                <tidy-text
                  [body]="'Remote Inspection'" />
              </div>
              <tidy-toggle
                [toggled]="remoteInspection"
                (toggleChanged)="toggleRemoteInspection()" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'Require pros to provide photos or videos so that you can remotely inspect each job.'" />
            </tidy-row>
            @if (remoteInspection) {
              <tidy-row class="extra-top-padding extra-bottom-padding">
                <tidy-divider />
              </tidy-row>
              <form [formGroup]="form" novalidate action="#">
                <tidy-row class="extra-bottom-padding">
                  <tidy-radio-button
                    formControlName="type"
                    [form]="form.controls.type"
                    [label]="'How would you like your pro to visually inspect?'"
                    [items]="typeItems"
                    [submitted]="submitted"
                    [errorMessage]="'Please select how to inspect.'" />
                </tidy-row>
                <tidy-row>
                  <tidy-radio-button
                    formControlName="when"
                    [form]="form.controls.when"
                    [label]="'When would you like them to inspect?'"
                    [items]="whenItems"
                    [submitted]="submitted"
                    [errorMessage]="'Please select when to inspect.'" />
                </tidy-row>
              </form>
            }
          }
        </form>
      </tidy-card>
      <tidy-button
        [text]="'Add Checklist'"
        [action]="boundAddList"
        class="primary" />
      @if (errorMessage) {
        <tidy-error-message
          [text]="errorMessage" />
      }

      <tidy-row class="extra-top-padding extra-bottom-padding">
        <tidy-divider />
      </tidy-row>

      <tidy-row class="extra-bottom-padding">
        <tidy-text [header]="'Start From Template'" />
      </tidy-row>

      @for (template of templates; track template.id) {
        <tidy-card
          class="template-card"
          [class.disabled]="isCreatingFromTemplate"
          (click)="!isCreatingFromTemplate && selectTemplate(template)">
          <tidy-card-button>
            <ion-row>
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="'assets/svg/document-text-outline.svg'"
                  class="body-size" />
              </tidy-row>
              <ion-col>
                <tidy-row>
                  <tidy-text [header]="template.name" />
                </tidy-row>
                <tidy-row>
                  <tidy-text [body]="template.description" />
                </tidy-row>
              </ion-col>
            </ion-row>
          </tidy-card-button>
        </tidy-card>
      }
    }

    @if (isCreatingFromTemplate) {
      <div class="loading-overlay">
        <div class="loading-overlay-content">
          <ion-spinner name="crescent" class="loading-spinner" style="display: flex;" />
          <tidy-text [header]="'Creating checklist...'" class="loading-text" />
        </div>
      </div>
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
